import ShowCharactersCommand from "./ShowCharactersCommand";
import ShowCharactersEditing from "./ShowCharactersEditing";
import ShowCharactersUI from "./ShowCharactersUI";

import "./ShowCharacters.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class ShowCharacters extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "ShowCharacters";
  }

  static get requires() {
    return [ShowCharactersCommand, ShowCharactersEditing, ShowCharactersUI];
  }
}
